import React from 'react'
import './Input.css'

export function Input({
  label,
  id,
  error,
  hint,
  type = 'text',
  required = false,
  className = '',
  ...props
}) {
  return (
    <div className={`field ${className}`}>
      {label && (
        <label htmlFor={id} className="field__label">
          {label}
          {required && <span className="field__required" aria-hidden="true"> *</span>}
        </label>
      )}
      <input
        id={id}
        type={type}
        className={`field__input ${error ? 'field__input--error' : ''}`}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        aria-invalid={!!error}
        required={required}
        {...props}
      />
      {hint && !error && (
        <p id={`${id}-hint`} className="field__hint">{hint}</p>
      )}
      {error && (
        <p id={`${id}-error`} className="field__error" role="alert">{error}</p>
      )}
    </div>
  )
}
